import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  createTheme,
  ThemeProvider,
  Button
} from "@mui/material";
import dayjs from "dayjs";
import PrimaryButton from "./primaryButton";
import SecondaryButton from "./secondaryButton";
import ThankyouIcon from '../assets/images/OBJECTS.svg'
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { handleDecodeJSON, handleEncodeJson } from "../utils/encodeDecodeJson";
import feedbackActions from "../Redux/feedback/actions";
import { useDispatch, useSelector } from "react-redux";
import useFetchCandidateTokenDetails from "../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../utils/auditLog";
import checkAuth from "./CheckAuth";
import usePreventBackNavigation from "../hooks/usePreventBackNavigation";
import PreventBackNavigationWarningModal from '../components/liveTest/preventBackNavigationWarningModal';
import examActions from "../Redux/exam/actions";

export default function ThankYou() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { heartBeat, candidateScore } = useSelector((state) => state.examReducer);
  const questionsList = useSelector(
    (state) => state.examReducer.questionsAndOptions?.questionsList);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [isReady, setIsReady] = useState(false);
  let candidateData = JSON.parse(sessionStorage.getItem("candidate_details"));
  const formatTwoDigit = (num) => String(num).padStart(2, "0");
  const [showBackWarning, setShowBackWarning] = useState(false);

  usePreventBackNavigation(setShowBackWarning);
  const scoreData = candidateScore?.data?.data;

  let isFeedback = candidateTokenDetails?.configuration?.feedback;
  let instantScore = candidateTokenDetails?.configuration?.instantScore;
  let instantResult = candidateTokenDetails?.configuration?.instantResult;
  let passingMarks = candidateTokenDetails?.configuration?.passingMarks;
  
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 700,
        lg: 1200,
        xl: 1536,
      },
    },
  });

  const handlePrint = () => {
    window.print();
  };


  useEffect(() => {
  if (instantScore || instantResult) {
      dispatch({
        type: examActions.GET_CANDIDATE_SCORE
      });
    }

    return () => {
      dispatch({ type: examActions.CLEAR_CANDIDATE_SCORE });
    };
  }, [dispatch,candidateTokenDetails, instantScore, instantResult]);

  const totalQuestions = questionsList
    ? Object.keys(questionsList).length
    : 0;

  const attemptedQuestions = questionsList
    ? Object.values(questionsList).filter(
      (q) =>
        q.status === "ANSWERED" ||
        q.status === "ANSWERED_AND_MARKED"
    ).length
    : 0;

  const notAttemptedQuestions = totalQuestions - attemptedQuestions;

   const getResultStatus = () => {
    if (!scoreData || !instantResult) return null;
    
    const obtainedMarks = scoreData.obtainedMarks || 0;
    return obtainedMarks >= passingMarks ? "Qualified" : "Not-Qualified";
  };

   const resultStatus = getResultStatus();


  const data = [
    {
      title: "Center Name",
      val: `: ${candidateTokenDetails?.configuration?.venueName}`,
    },
    {
      title: "Candidate Name",
      val: `:  ${candidateData?.candidateName}`,
    },
    {
      title: "Roll No",
      val: `:  ${candidateData?.rollNo}`,
    },
    {
      title: "Exam Date",
      val: `:  ${dayjs(candidateData?.startTime).format("DD MMM, YYYY")}`,
    },
    {
      title: "Total Questions",
      val: `: ${totalQuestions}`,
    },
    {
      title: "Total Attempted",
      val: `: ${formatTwoDigit(attemptedQuestions)}`,
    },
    {
      title: "Total Not Attempted",
      val: `: ${formatTwoDigit(notAttemptedQuestions)}`,
    },

  ];

   if (instantScore && scoreData) {
    data.push(
      {
        title: "Score Obtained",
        val: `: ${formatTwoDigit(scoreData.obtainedMarks || 0)}`,
      }
    );
  }

  if (instantResult && scoreData) {
    data.push({
      title: "Status",
      val: `: ${resultStatus}`,
    });
  }

  
  useEffect(() => {
    checkAuth(navigate)
  }, [])

  useEffect(() => {
  if (candidateTokenDetails && questionsList == undefined) {
    setIsReady(true);
  }
}, [candidateTokenDetails, questionsList]);


useEffect(() => {
  if (isReady === false) return;

  if (!candidateTokenDetails || !questionsList) {
    navigate(`/${Cookies.get("test_engine_project")}/login`, { replace: true });
  }
}, [isReady, candidateTokenDetails, questionsList, navigate]);


  const handleFeedback = async () => {
    sessionStorage.setItem('isInFeedback', true)
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Feedback Review",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    const formData = {
      imageSize: "L",
      language: "english",
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: feedbackActions.GET_FEEDBACK_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  const handleExit = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Exit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    Cookies.remove("test_engine_token");
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace(`/${Cookies.get("test_engine_project")}/login`);
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100svh',      
          backgroundColor: "#EBF2FF",
        }}
      >
        <Container maxWidth="md" disableGutters sx={{ px: 2 }}>
          <Box
            sx={{
              p: {
                xs: 1,
                md: 3
              },
              bgcolor: "#fff",
              textAlign: "center",
            }}
          >
            <img src={ThankyouIcon} alt="Thank you" height={150} width={150} />
            <Typography
              sx={{
                fontWeight: "bold",
                color: "rgba(63, 65, 209, 1)",
                fontSize: { xs: "16px", md: "24px" },
                pt: 2,
                pb: 2,
              }}
            >
              Thank you! <br />
              Your Exam Submitted Successfully.
            </Typography>
            {data?.map((v, i) => (
              <Grid
                container
                key={i}
                p={1}
                sx={{
                  borderBottom: "1px solid rgba(30, 30, 30, 0.1)",
                  color: "#1E1E1E",
                  alignItems: "flex-start",   //  important
                }}
              >
                {/* TITLE */}
                <Grid
                  item
                  xs={6}      
                  sm={4}
                  md={4}
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: "bold",
                    textAlign: "start",
                    whiteSpace: "nowrap",     //  title ek line me rahe
                  }}
                >
                  {v?.title}
                </Grid>
                {/* VALUE */}
                <Grid
                  item
                  xs={6}      //  mobile width
                  sm={8}
                  md={7}
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    lineHeight: "20px",
                    textAlign: "start",
                    fontWeight: 400,

                    wordBreak: "break-word",   //  wrap long text
                    overflowWrap: "anywhere",  // force wrap
                  }}
                >
                  {v?.val}
                </Grid>
              </Grid>
            ))}
            <Grid
              container
              pt={2}
              spacing={2}
              justifyContent="center"
            >
              {/* EXIT BUTTON */}
              <Grid item xs={12} md={6}>
                <Button
                  onClick={handleExit}
                  sx={{
                    width: "100%",               // 🔥 full width on mobile
                    color: isFeedback
                      ? "rgba(63, 65, 209, 1)"
                      : "white",
                    backgroundColor: isFeedback
                      ? "white"
                      : "rgba(63, 65, 209, 1)",
                    border: "1px solid rgba(63, 65, 209, 1)",
                    borderRadius: "20px",
                    '&:hover': {
                      backgroundColor: 'rgba(63, 65, 209, 1)',
                      opacity: '0.9'
                    }
                  }}
                >
                  Exit
                </Button>
              </Grid>

              {/* PRINT BUTTON */}
              <Grid item xs={12} md={6}>
                <Button
                  onClick={handlePrint}
                  sx={{
                    width: "100%",               // 🔥 full width on mobile
                    color: "rgba(63, 65, 209, 1)",
                    backgroundColor: "white",
                    border: "1px solid rgba(63, 65, 209, 1)",
                    borderRadius: "20px",
                  }}
                >
                  Print
                </Button>
              </Grid>

              {/* FEEDBACK BUTTON (optional) */}
              {isFeedback && (
                <Grid item xs={12}>
                  <Button
                    onClick={handleFeedback}
                    sx={{
                      width: "100%",
                      color: "white",
                      backgroundColor: "rgba(63, 65, 209, 1)",
                      border: "1px solid rgba(63, 65, 209, 1)",
                      borderRadius: "20px",
                    }}
                  >
                    Continue to Feedback
                  </Button>
                </Grid>
              )}
            </Grid>

          </Box>
        </Container>
      </Box>

      {showBackWarning && (
        <PreventBackNavigationWarningModal
          {...{showBackWarning, setShowBackWarning}}
        />
      )}

    </ThemeProvider>
  );
}
